// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import '@/styles/index.scss'
import App from './App'
import router from './router'
import store from './store'
import './permission'
import './icons'
import VueRouter from 'vue-router'

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

import PinyinMatch from 'pinyin-match'
Vue.prototype.$pinyinmatch = PinyinMatch
import * as filters from './filters'

// 动态粒子特效背景
import VueParticles from 'vue-particles'
Vue.use(VueParticles);

//引入echarts
import echarts from 'echarts'
// import 'echarts/map/js/china'
Vue.prototype.$echarts = echarts;

// 引入高德地图
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  // key: '3faa0c60420dd34bbddae10390e1e6fd',
  key: 'bbf9822293a61693c16c3177b2a7af25',
  plugin: [
      'AMap.Autocomplete', // 输入提示插件
      'AMap.PlaceSearch', // POI搜索插件
      'AMap.Scale', // 右下角缩略图插件 比例尺
      'AMap.OverView', // 地图鹰眼插件
      'AMap.ToolBar', // 地图工具条
      'AMap.MapType', // 类别切换控件，时间默认图层与卫星图、实施交通图层之间切换的控制
      'AMap.PolyEditor', // 编辑 折线 多边形
      'AMap.CircleEditor',// 圆形编辑器插件
      'AMap.Geolocation', // 定位控件,用来获取和展示用户主机所在的经纬度位置
    ],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4',
	uiVersion: '1.0'
});

import animate from 'animate.css'

Vue.use(animate)

//引入swiper
import swiper from 'swiper'
Vue.prototype.$swiper = swiper;

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(ElementUI)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
		store,
    router,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js